import { useState, useRef, useEffect, MutableRefObject } from 'react';

export const useHover = <HTML extends HTMLElement>(): [MutableRefObject<HTML | null>, boolean] => {
  const [value, setValue] = useState(false);

  const ref = useRef<HTML>(null);

  const handleMouseOver = () => setValue(true);
  const handleMouseOut = () => setValue(false);
  // biome-ignore lint/correctness/useExhaustiveDependencies: exception
  useEffect(() => {
    const node = ref?.current;
    if (node) {
      node.addEventListener('mouseover', handleMouseOver);
      node.addEventListener('mouseout', handleMouseOut);
    }
    return () => {
      node?.removeEventListener('mouseover', handleMouseOver);
      node?.removeEventListener('mouseout', handleMouseOut);
    };
  }, [ref?.current]);

  return [ref, value];
};
